<template>
  <div>
    <NotificationUnread @updateUnreadCount="onUpdateCount"></NotificationUnread>
    <tabbar v-model="barActive" @change="onChange" active-color="#fc9153" :safe-area-inset-bottom="true">
      <tabbar-item v-for="item in tabbarList" :key="item.name" :name="item.name">
        <span>{{item.name}}</span>
        <template #icon="props">
          <icon-svg :icon-class="props.active ? item.iconFill: item.icon" class="icon-info"/>
        </template>
      </tabbar-item>
    </tabbar>
  </div>
</template>

<script>
  import {Tabbar, TabbarItem} from 'vant';
  import NotificationUnread from "./NotificationUnread";
  import {TabbarConfig} from "../../util/const"

  export default {
    name: "TabbarComponent",
    components: {
      NotificationUnread, Tabbar, TabbarItem
    },
    data() {
      return {
        barActive: 0,
        isLogin: true,
        badgeMomentTab: "",
        tabbarList: TabbarConfig,
        tabbarMap: {},
      }
    },
    mounted() {
      this.init()
      this.initUserInfo()
      for (let i = 0; i < this.tabbarList.length; i ++) {
        this.tabbarMap[this.tabbarList[i].name] = this.tabbarList[i]
      }
    },

    activated() {
      this.init()
      this.initUserInfo()
    },

    methods: {
      initUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data && data.id) {
            this.isLogin = true
          } else {
            this.isLogin = false
          }
        }, () => {
        })
      },

      onUpdateCount(data) {
        this.badgeMomentTab = data
      },

      onChange(tabName) {
        let tabbarConfig = this.tabbarMap[tabName]
        if (!tabbarConfig) {
          return
        }

        let path = "/"
        if (!this.isLogin && tabbarConfig.login) {
          path = "/login"
        } else {
          path = tabbarConfig.path || "/"
        }
        this.$router.push(path)
      },

      init() {
        let fullPath = this.$route.path;
        for (let i = 0; i < this.tabbarList.length; i ++) {
          if (fullPath.indexOf(this.tabbarList[i].pathIndex) > -1) {
            this.barActive = this.tabbarList[i].name
            return
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

  .icon-info {
    font-size: 20px;
  }

</style>
